/* RBN: temporary cart-focus performance mode; activated only while the drawer is open. */
(function(){
 'use strict';
 function init(){
   var drawer=document.getElementById('cart-drawer');
   if(!drawer)return;
   var root=document.documentElement;
   var current=null;
   var pausedVideos=new Set();
   function sync(){
     var open=drawer.hasAttribute('open')||!!drawer.querySelector('dialog[open]');
     if(open===current)return;
     current=open;
     root.classList.toggle('rbn-cart-is-open',open);
     if(open){
       document.querySelectorAll('.page-wrapper video.rbn-banner__video,.page-wrapper video.rbn-banner__dvideo')
         .forEach(function(v){if(!v.paused){pausedVideos.add(v);v.pause();}});
     }else{
       pausedVideos.forEach(function(v){if(v.isConnected&&!document.hidden){var p=v.play();if(p&&p.catch)p.catch(function(){});}});
       pausedVideos.clear();
     }
     document.dispatchEvent(new CustomEvent('rbn:cart-focus-change',{detail:{open:open}}));
   }
   var mo=new MutationObserver(sync);
   mo.observe(drawer,{attributes:true,attributeFilter:['open']});
   var dialog=drawer.querySelector('dialog');
   if(dialog)mo.observe(dialog,{attributes:true,attributeFilter:['open']});
   document.addEventListener('theme-drawer:open',function(){requestAnimationFrame(sync);});
   document.addEventListener('theme-drawer:close',function(){requestAnimationFrame(sync);});
   document.addEventListener('play',function(e){
     if(current&&e.target instanceof HTMLVideoElement &&
       e.target.matches('.page-wrapper video.rbn-banner__video,.page-wrapper video.rbn-banner__dvideo'))e.target.pause();
   },true);
   window.addEventListener('pageshow',sync);
   sync();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();